<template>
  <div class="vehicle-modal-window">
    <v-container fill-height fluid>
      <v-row 
        align="center"
        justify="center">
        <v-card class="device-selector-container">
          <v-row>
            <v-col cols="12">
              <div class="vehicle-heading-info">
                <div class="vehicle-icon">
                  <v-icon color="white">mdi-car</v-icon>
                </div>
                <h3> {{ panelHeading }} </h3>
                <v-icon 
                  large 
                  color="red"
                  class="close-btn"
                  @click.native="emitHandler('toggleModal', false)">
                  mdi-close
                </v-icon>
              </div>
            </v-col>
      
            <v-col cols="12">
              <div class="wrapper">
                <v-tabs 
                  v-model="tab" 
                  class="tab-heading">
                  <v-tab>Vehicle</v-tab>
                  <v-tab :disabled="allowDeviceConfig">Devices</v-tab>
                </v-tabs>
                <v-tabs-items
                  v-model="tab"
                  class="tab-content">
                  <v-tab-item
                    :disabled="multiDevice">
                    <pvcam-wc-vehicle-config 
                      :items="JSON.stringify(items)"
                      :groups="JSON.stringify(groups)"
                      :vehicle-types="JSON.stringify(vehicleTypes)"
                      :org="JSON.stringify(org)"
                      :nodes="JSON.stringify(nodes.root_node)"
                      :multi-device="JSON.stringify(multiDevice)"
                      :selected-contacts="JSON.stringify(selectedContacts)"
                      :admin="true"
                      :translate="JSON.stringify(false)"
                      @showSelectContacts="handleSelection"
                      @refreshData="refreshData"/>
                  </v-tab-item>
                  <v-tab-item
                    :disabled="multiDevice">
                    <pvcam-wc-devices-config 
                      :items="JSON.stringify(items)"
                      :groups="JSON.stringify(groups)"
                      :org="JSON.stringify(org)"
                      :multi-device="JSON.stringify(multiDevice)"
                      :selected-contacts="JSON.stringify(selectedContacts)"
                      :user-info="JSON.stringify({})"
                      :admin-user="true"
                      @showSelectContacts="handleSelection"
                      @refreshData="refreshData"/>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>

// import { Logger } from "aws-amplify";
// const logger = new Logger("Config Panel");

export default {
  name: 'ConfigPanel',
  props: {
    items: {
      type: Array,
      required: true
    },
    groups: {
      type: Array,
      required: true
    },
    vehicleTypes: {
      type: Array,
      required: true
    },
    multiDevice: {
      type: Boolean,
      required: true
    },
    selectedContacts: {
      type: Object,
      required: true
    },
    org: {
      type: String,
      required: true
    },
    nodes: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tab: null
    }
  },
  computed: {
    allowDeviceConfig() {
      if (this.items.length > 1) {
        return this.multiDevice ? false : true;
      } else {
        return false;
      } 
    },
    panelHeading() {
      return this.items.length > 1 ? 'Multiple Vehicles Selected' : this.items[0].vehicle_name;
    }
  },
  mounted() {
    window.$translate = () => {
      // logger.info('translate', section, value)
    }
  },
  methods: {
    handleSelection(value) {
      this.$emit('showSelectContacts', value)
    },
    emitHandler(identifier, value) {
      this.$emit(identifier, value);
    },
    refreshData(data) {
      this.$emit('refreshData', data);
    }
  }
}
</script>

<style lang="scss">
  .v-tabs-slider-wrapper {
    height: 10px !important;
    color: #24AB80 !important;
  }
  .vehicle-icon {
    font-size: 40px !important;
    padding-right: .25em;
  }
  .vehicle-heading-info {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #24AB80;
    width: 100%;
    z-index: 40;
    color: white;
  }
  .vehicle-modal-window {
    z-index: 9998;
    position: fixed;
    left: 0%;
    right: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4);
    width: 100vw;
    height: 100vh;
    .tab-heading {
      padding-bottom: 1em;
      padding-left: 1em;
      padding-right: 1em;
    }
    .tab-content {
      padding-left: 1em;
      padding-right: 1em;
    }
    .device-selector-container {
      position: relative;
      width: 800px;
      height: 800px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      overflow-y:auto ;
      overflow-x: hidden;
      .wrapper {
        overflow-y: auto;
        height: 100%;
        width: 100%;
        padding: 0;
      }
      .close-btn {
        position: absolute;
        z-index: 50;
        top: 0;
        right: 0;
        cursor: pointer;
        cursor: pointer;
      }
    }
  }
</style>